<template>
  <div id="group-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content"
      :class="{
        'section-loading': isLoading_1
      }">
        <div class="modal-body">
          <section class="search">
            <div class="row">
              <div class="col-10 offset-1">
                <form class="form">
                  <div class="input-group input-lg">
                    <div class="input">
                      <input
                      type="text"
                      name="keyword"
                      id="keyword"
                      class="form-control"
                      @input="findGroup"
                      @blur="findGroup"
                      v-model="keyword"
                      placeholder="請以關鍵字搜尋一個群組加入或新增一個群組"
                      maxlength="50"
                      />
                    </div>
                    <button
                    class="btn btn-primary btn-icon"
                    type="submit"
                    @click.stop.prevent="findGroup()">
                      <i class="icon-search i-24"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
          <section class="maintain">
            <div class="row">
              <div class="col-10 offset-1" v-if="groupList.length">
                <h4>{{tempSelection}}</h4>
                <div class="list recommand">
                  <a role="button" class="item"
                  :class="{'selected': selection!==null && selection.grp_id === item.grp_id}"
                  @click="selectGroup(item)"
                  v-for="(item, rid) in groupList" :key="`recommand-${rid}`">
                    <h3>{{item.grp_name}}</h3>
                  </a>
                </div>
              </div>
              <div class="col-10 offset-1 text-center" v-else>
                <h3>查無此群組名稱，請問是否新增？</h3>
                <a role="button" class="btn btn-border-green"
                @click="addNewGroup()">
                  <i class="icon-add_new"></i>
                  <span class="text">新增群組「{{keywordAdd}}」</span>
                </a>
              </div>
            </div>
          </section>
          <section class="action text-right">
            <div class="error-block" v-if="error">
              <span class="error text-center">
                請先選擇一個欲加入的群組名稱。
              </span>
            </div>
            <a
            class="btn btn-default"
            @click="doCancel">
              取消
            </a>
            <a
            class="btn btn-primary"
            @click="doSubmit"
            v-if="selection !== null">
              確認
            </a>
            <a
            v-else
            class="btn btn-primary"
            disabled>
              確認
            </a>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { getGroupOfAgnt } from '../../service';
import { updateGroup } from '../../service';
import { getCustInfo } from '../../service';

import { getGroupMember } from '../../service';
import { updateGrpMem } from '../../service';
import { log } from 'util';
// const recommandList = [
//   {
//     grp_name: '滿期年金',
//     grp_id: '001'
//   }
// ]

export default {
  name: 'GroupModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    custs:{
      type: Array
    }, 
    currentPage:{
      type: String, 
      default:''
    }
  },
  data () {
    return {
      error: false,
      isLoading_1: false,
      keyword: '',
      recommandList: [],
      groupList: [],
      selection: null,
      tempSelection: null,
      selectedMemOri: [],
      keywordAdd:'',
    }
  },
  watch: {
    'open': 'getAllGroup'
  },
  methods: {
    getAllGroup() {
      if(this.open) {
        this.selection = null
        this.keyword = ''
        this.keywordAdd = ''
        this.isLoading_1 = true
        getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id,0).then(result => {
          if(result.body.groups && result.body.groups.length > 0) {
            this.recommandList = result.body.groups.map(item => {
              return {
                grp_id : item.grp_id,
                grp_name: item.grp_name
              }
            })
            this.groupList = this.recommandList.map(item => item)
            if(this.keyword != '') {
              this.groupList.forEach(item => {
                if(this.keyword === item.grp_name) {
                  this.selectGroup(item)
                  this.keyword = ''
                }
              });
            }
            // this.groupList = window._.clone(this.recommandList)

          } else {
            this.recommandList = []
            this.groupList = []
          }
          this.isLoading_1 = false
        })
      }
    },
    initList () {
      this.groupList = [...this.recommandList]
      // this.groupList = window._.clone(this.recommandList)
    },
    findGroup () {
      //檢查輸入欄位  
      this.keyword = this.keyword.replace(/[<>!#$^&,"'?%*:;+{}[\]|~`=\\]/g,'');
      if (this.stringBytes(this.keyword, false, 50) > 50) {
        this.keyword = this.keyword.substring(0, this.stringBytes(this.keyword, true ,50));
      }
      this.selection = null
      if (this.keyword === '') {
        this.initList()
      } else {
        this.groupList = this.recommandList.filter(item => {
          return item.grp_name.includes(this.keyword)
        })
      }
      this.keywordAdd = this.keyword + ''
    },
    select (item) {
      console.log(item)
      this.selection = item
    },
    addNewGroup () {
      let $this = this;
      $this.isLoading_1 = true
      let insertList = [];
      for(let i = 1; i<$this.custs.length+1; i++){
        let selectID = $this.custs[i-1]
        if($this.selectedMemOri.indexOf(selectID) == -1) {
          let insertMap = {}
          insertMap['identity'] = selectID
          insertList[i] = insertMap
        }
      }

      if($this.currentPage === 'customerCreate') {
        insertList = []
      } 
      updateGroup(this.$store.state.userInfo.id, null, $this.keyword, insertList).then(result => {
        // $this.keyword = ''
        if(result.header.status == 200) {
          if($this.currentPage === 'customerCreate') {
            this.$toast.info({title: result.header.message, timeOut: '10000'})
            this.$emit('submit', result.body)
          } else {
            console.log('test !!!!!!!!!!!!!!!!!!!!!!!!!')
            this.$toast.info({title: result.header.message, timeOut: '10000'})
            this.$emit('submit', result.body)
            this.$emit('close')
          }
        } else {
          this.$toast.info({title: result.header.message, timeOut: '10000'})    
        }
        $this.getAllGroup()
      })
      $this.isLoading_1 = false
    },
    doSubmit () {
      let $this = this

      if($this.currentPage === 'customerCreate') {
        this.$emit('submit', this.selection)
      } else {

        if(!this.selection) {
          this.error = true
        } else {
          let compareAry = []
          getGroupMember(this.$store.state.userInfo.id, this.selection.grp_id).then(result => {
            if(result) {
              compareAry = result.map(cust => {
                return cust.ID
              })
            } else {
              compareAry = []
            }
            // 過濾重複 ID, insert 新ID
            $this.custs.forEach(custId => {
              if (!compareAry.includes(custId)) {
                compareAry.push(custId)
              }
            })
            
            //更新群組
            updateGrpMem(this.$store.state.userInfo.id, this.selection.grp_id, this.selection.grp_name, compareAry).then(result => {
              if(result.header.status == 200) {
                this.$toast.info({title: result.header.message})
                this.$emit('submit', this.selection)
              } else {
                this.$toast.info({title: result.header.message})  
                this.$emit('close')  
              }
            })
          })
        }

      }
    },
    selectGroup (group) {
      this.selection = group
    },
    doCancel() {
      this.selection = []
      this.$emit('close')
    },
    stringBytes(c, isSub, size){ //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n=c.length,s;
      var len=0;
      for(var i=0; i <n;i++){
        s=c.charCodeAt(i);
        while( s > 0 ){
          len++;
          s = s >> 8;
          if(isSub&&len>size){
            return i;
          }
        }
      }
      return len;
    }
  }
}
</script>
